// wegogolf-app/src/context/RoleContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { supabase } from '../services/supabase';

const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const { user } = useAuth();
  const [isManager, setIsManager] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkManagerRole = async () => {
      if (user?.id) {
        setIsAuthenticated(true);
        try {
          const { data: isManager, error } = await supabase
            .rpc('check_user_role_with_user_id', { 
              required_role: 'manager', 
              p_user_id: user.id 
            });
          
          if (error) throw error;
          setIsManager(isManager);
        } catch (error) {
          console.error('Error checking manager role:', error);
          setIsManager(false);
        }
      } else {
        setIsAuthenticated(false);
        setIsManager(false);
      }
    };

    checkManagerRole();
  }, [user]);


  return (
    <RoleContext.Provider value={{ isManager, isAuthenticated }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRoleContext = () => {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error('useRoleContext must be used within a RoleProvider');
  }
  return context;
};